export default [
  {
    name: 'RoulettesFieldsList',
    path: 'settings/roulettes-fields',
    component: () => import('pages/settings/roulettes-fields/RoulettesFieldsList.vue')
  },
  {
    name: 'RoulettesFieldsCreate',
    path: 'settings/roulettes-fields/new',
    component: () => import('pages/settings/roulettes-fields/RoulettesFieldsForm.vue')
  },
  {
    name: 'RoulettesFieldsEdit',
    path: 'settings/roulettes-fields/:id/edit',
    component: () => import('pages/settings/roulettes-fields/RoulettesFieldsForm.vue')
  },
  {
    name: 'RoulettesFieldsSingle',
    path: 'settings/roulettes-fields/:id',
    component: () => import('pages/settings/roulettes-fields/RoulettesFieldsSingle.vue')
  }
]
